import React from 'react'
import { Skeleton, csx } from '@vtex/admin-ui'

import { IndicatorCardContainer } from './IndicatorCardContainer'
import { IndicatorCardContent } from './IndicatorCardContent'
import { IndicatorCardsContainer } from './IndicatorCards'
import { IndicatorComparisonContainer } from './IndicatorComparisonContainer'

export const IndicatorCardsSkeleton = () => (
  <IndicatorCardsContainer data-testid="sales-performance__indicator-cards-skeleton">
    <>
      {[...Array(3).keys()].map((_, index) => (
        <IndicatorCardContainer key={index}>
          <Skeleton className={csx({ width: '75%', height: '1.125rem' })} />
          <IndicatorCardContent>
            <IndicatorComparisonContainer>
              <Skeleton className={csx({ width: '25%', height: '1.125rem' })} />
            </IndicatorComparisonContainer>
          </IndicatorCardContent>
        </IndicatorCardContainer>
      ))}
      {[...Array(3).keys()].map((_, index) => (
        <IndicatorCardContainer key={index}>
          <Skeleton className={csx({ width: '75%', height: '1.125rem' })} />
          <IndicatorCardContent>
            <Skeleton className={csx({ width: '15%', height: '1rem' })} />
            <IndicatorComparisonContainer>
              <Skeleton className={csx({ width: '25%', height: '1.125rem' })} />
              <Skeleton className={csx({ width: '15%', height: '1.125rem' })} />
            </IndicatorComparisonContainer>
          </IndicatorCardContent>
        </IndicatorCardContainer>
      ))}
    </>
  </IndicatorCardsContainer>
)
